var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "scrollContainer",
      staticClass: "container",
      staticStyle: { width: "100%", height: "100%", "overflow-y": "auto" },
      on: { scroll: _vm.scrollToTop },
    },
    [
      _c("breadcrumb", { attrs: { breadcrumbConfig: _vm.breadcrumbConfig } }),
      _c(
        "div",
        { attrs: { id: "printContext" }, on: { click: _vm.printT } },
        [
          _c("printModel", {
            staticStyle: { display: "none" },
            attrs: { printData: _vm.printData },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("h2", [_vm._v("物流订单")]),
          _c("h3", [_vm._v("数据筛选")]),
          _c("form-filed", {
            ref: "formAttr",
            staticClass: "search-form",
            attrs: {
              formconfig: _vm.searchFormConfig.formconfig,
              formData: _vm.searchFormConfig.formData,
            },
            on: {
              cascaderValue: _vm.handlerCascaderValue,
              formDataval: _vm.dialogClick,
              formDataval1: _vm.dialogClick1,
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("h3", [_vm._v("列表数据")]),
          _c("div", { staticClass: "but-list" }, [
            _c(
              "div",
              { staticClass: "left" },
              _vm._l(_vm.logisticsStatus, function (val, key) {
                return _c(
                  "el-button",
                  {
                    key: key,
                    attrs: {
                      disabled: _vm.loading,
                      type:
                        _vm.currentStatus === val.values ? "primary" : "info",
                      size: "small",
                      plain: "",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.onChangeLogisticsStatus(val.values)
                      },
                    },
                  },
                  [
                    _vm._v(_vm._s(val.title)),
                    key === "stayStockUp" ||
                    key === "stockUp" ||
                    key === "stayDeliverGoods"
                      ? _c("span", [_vm._v("（" + _vm._s(val.total) + "）")])
                      : _vm._e(),
                  ]
                )
              }),
              1
            ),
            _c(
              "div",
              { staticClass: "right" },
              [
                _vm.currentStatus ===
                _vm.logisticsStatus.stayDeliverGoods.values
                  ? _c(
                      "el-button",
                      {
                        staticClass: "stock-up-send-but2",
                        attrs: { type: "primary", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.onUndo()
                          },
                        },
                      },
                      [_vm._v("取消发货 ")]
                    )
                  : _vm._e(),
                _vm.currentStatus === _vm.logisticsStatus.stayStockUp.values
                  ? _c(
                      "el-button",
                      {
                        staticClass: "stay-stock-up-but",
                        attrs: { type: "primary", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.onStockUp(true)
                          },
                        },
                      },
                      [_vm._v("批量备货 ")]
                    )
                  : _vm._e(),
                _vm.currentStatus === _vm.logisticsStatus.stockUp.values
                  ? _c(
                      "span",
                      {
                        staticStyle: {
                          color: "#FF0000",
                          "font-size": "14px",
                          "margin-right": "20px",
                        },
                      },
                      [_vm._v("* 生成面单前请确认已拆完订单")]
                    )
                  : _vm._e(),
                _vm.currentStatus === _vm.logisticsStatus.stockUp.values
                  ? _c(
                      "el-button",
                      {
                        staticClass: "stock-up-send-but1",
                        attrs: { type: "primary", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.openProuductOrder()
                          },
                        },
                      },
                      [_vm._v("生成电子面单 ")]
                    )
                  : _vm._e(),
                _vm.currentStatus ===
                _vm.logisticsStatus.stayDeliverGoods.values
                  ? _c(
                      "el-button",
                      {
                        staticClass: "stock-up-send-but",
                        attrs: { type: "primary", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.onPrintOrder()
                          },
                        },
                      },
                      [_vm._v("打印面单 ")]
                    )
                  : _vm._e(),
                _vm.currentStatus === _vm.logisticsStatus.stockUp.values
                  ? _c(
                      "el-button",
                      {
                        staticClass: "stock-up-send-but",
                        attrs: { type: "primary", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.deriveDeliverGoods1()
                          },
                        },
                      },
                      [_vm._v("导出拣货单 ")]
                    )
                  : _vm._e(),
                _vm.currentStatus === _vm.logisticsStatus.stockUp.values
                  ? _c(
                      "el-button",
                      {
                        staticClass: "stock-up-send-but",
                        attrs: { type: "primary", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.deriveDeliverGoods()
                          },
                        },
                      },
                      [_vm._v("导出发货 ")]
                    )
                  : _vm._e(),
                _vm.currentStatus === _vm.logisticsStatus.stockUp.values
                  ? _c(
                      "el-button",
                      {
                        staticClass: "stock-up-record-but",
                        attrs: { type: "primary", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.onApplierExport("1")
                          },
                        },
                      },
                      [_vm._v("导出记录 ")]
                    )
                  : _vm._e(),
                _vm.currentStatus ===
                _vm.logisticsStatus.stayDeliverGoods.values
                  ? _c(
                      "el-button",
                      {
                        staticClass: "stay-deliver-goods-but",
                        attrs: { type: "primary", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.importLogisticsData(3)
                          },
                        },
                      },
                      [_vm._v("导出 ")]
                    )
                  : _vm._e(),
                _vm.currentStatus === _vm.logisticsStatus.all.values
                  ? _c(
                      "el-button",
                      {
                        staticClass: "stay-deliver-goods-but",
                        attrs: { type: "primary", size: "small" },
                        on: { click: _vm.totalExport },
                      },
                      [_vm._v("导出 ")]
                    )
                  : _vm._e(),
                _vm.currentStatus === _vm.logisticsStatus.afterSale.values
                  ? _c(
                      "el-button",
                      {
                        staticClass: "stay-deliver-goods-but",
                        attrs: { type: "primary", size: "small" },
                        on: { click: _vm.afterExport },
                      },
                      [_vm._v("导出 ")]
                    )
                  : _vm._e(),
                _vm.currentStatus ===
                _vm.logisticsStatus.stayDeliverGoods.values
                  ? _c(
                      "el-button",
                      {
                        staticClass: "stay-deliver-goods-but",
                        attrs: { type: "primary", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.leadingIn()
                          },
                        },
                      },
                      [_vm._v("导入物流单 ")]
                    )
                  : _vm._e(),
                _vm.currentStatus === _vm.logisticsStatus.deliverGoods.values
                  ? _c(
                      "el-button",
                      {
                        staticClass: "deliver-goods-but",
                        attrs: { size: "small" },
                        on: { click: _vm.batchAmend },
                      },
                      [_vm._v("批量修改物流单号 ")]
                    )
                  : _vm._e(),
                _vm.currentStatus === _vm.logisticsStatus.deliverGoods.values
                  ? _c(
                      "el-button",
                      {
                        attrs: {
                          size: "small",
                          type: "primary",
                          loading: _vm.btnLoading,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.importLogisticsData(4)
                          },
                        },
                      },
                      [_vm._v("导出物流数据 ")]
                    )
                  : _vm._e(),
                _vm.currentStatus === _vm.logisticsStatus.afterSale.values
                  ? _c(
                      "el-button",
                      {
                        staticClass: "stay-deliver-goods-but",
                        attrs: { type: "primary", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.afterSaleLeadingIn()
                          },
                        },
                      },
                      [_vm._v("批量导入换货单号 ")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm.showTable
            ? _c("lb-table3", {
                directives: [
                  {
                    name: "horizontal-scroll",
                    rawName: "v-horizontal-scroll",
                    value: "always",
                    expression: "'always'",
                  },
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loadinglist,
                    expression: "loadinglist",
                  },
                ],
                ref: "tableData",
                attrs: {
                  tableHeight: _vm.tableHeight,
                  column: _vm.columns,
                  expandRowKeys: _vm.expandRowKeys,
                  data: _vm.page.list,
                  pagination: "",
                  total: _vm.page.totalNum,
                  layout: "total, sizes, prev, pager, next, jumper",
                  "page-sizes": [5, 10, 20, 30, 50, 200],
                  "current-page": _vm.page.currentPage,
                  "page-size": _vm.page.pageSize,
                },
                on: {
                  sortChange: _vm.handleSortChange,
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.page, "currentPage", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.page, "currentPage", $event)
                  },
                  "size-change": _vm.handleSizeChange,
                  "p-current-change": _vm.handleCurrentChange,
                  "selection-change": _vm.handleSelectionChange,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialog.title,
            visible: _vm.dialog.visible,
            width: _vm.dialog.width,
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialog, "visible", $event)
            },
          },
        },
        [
          _vm.dialog.type === "shenheStep"
            ? [
                _c("step-progress", {
                  attrs: {
                    orderObj: _vm.dialog.row,
                    processFunc: _vm.dictionaries.process_func,
                    type: "shenheStep",
                  },
                }),
              ]
            : _vm._e(),
          _vm.dialog.type === "modifyOrderNoOne"
            ? [
                _c("modify-order-no", {
                  ref: "modifyOrderNo",
                  attrs: {
                    orderObj: _vm.dialog.row,
                    type: _vm.dialog.type,
                    source: "service",
                  },
                  on: { submitState: _vm.modifyState },
                }),
              ]
            : _vm._e(),
          _vm.dialog.type === "wuliuAbnormal"
            ? [
                _c("div", { staticClass: "wuliuAbnormal_box" }, [
                  _c("div", { staticClass: "wuliuAbnormal_box_title" }, [
                    _vm._v("异常原因"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "radio_group" },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.wuliuStatus.resource,
                            callback: function ($$v) {
                              _vm.$set(_vm.wuliuStatus, "resource", $$v)
                            },
                            expression: "wuliuStatus.resource",
                          },
                        },
                        _vm._l(
                          _vm.dictionaries.logistics_exception_reason,
                          function (item, index) {
                            return _c(
                              "el-radio",
                              {
                                key: index,
                                staticClass: "radio_group_item",
                                staticStyle: { display: "block" },
                                attrs: { label: item.dictId },
                              },
                              [_vm._v(_vm._s(item.dictName) + " ")]
                            )
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c(
                  "el-form",
                  {
                    staticClass: "audit_textarea",
                    attrs: { "label-width": "65px" },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "备注" } },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: "请输入备注",
                            maxlength: "200",
                            "show-word-limit": "",
                            type: "textarea",
                          },
                          model: {
                            value: _vm.wuliuStatus.remark,
                            callback: function ($$v) {
                              _vm.$set(_vm.wuliuStatus, "remark", $$v)
                            },
                            expression: "wuliuStatus.remark",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "dialogBtnright dialogBtnright_right",
                    staticStyle: { "margin-top": "20px" },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "setPay_payment_btn_quxiao",
                        on: {
                          click: function ($event) {
                            _vm.dialog.visible = false
                          },
                        },
                      },
                      [_vm._v("取 消")]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "setPay_payment_btn_queren",
                        attrs: { type: "primary" },
                        on: { click: _vm.handlerAuditsubmit },
                      },
                      [_vm._v("确 定")]
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.dialog.type === "logisticsMessageOne"
            ? [
                _c("step-progress", {
                  attrs: {
                    orderObj: _vm.dialog.row,
                    type: "logisticsMessageOne",
                    source: "service",
                  },
                }),
              ]
            : _vm._e(),
          _vm.dialog.type === "outStock"
            ? [
                [_c("p", [_vm._v("该订单是否要做缺货处理？")])],
                _c(
                  "div",
                  {
                    staticClass: "dialogBtnright dialogBtnright_right",
                    staticStyle: { "margin-top": "20px" },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "setPay_payment_btn_quxiao",
                        on: {
                          click: function ($event) {
                            _vm.dialog.visible = false
                          },
                        },
                      },
                      [_vm._v("取 消")]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "setPay_payment_btn_queren",
                        attrs: { type: "primary" },
                        on: { click: _vm.onOutStock },
                      },
                      [_vm._v("确 定")]
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.dialog.type === "closeOrder"
            ? [
                _vm.dialog.row.orderGenerateType == 1
                  ? [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.setCloseOrder,
                            callback: function ($$v) {
                              _vm.setCloseOrder = $$v
                            },
                            expression: "setCloseOrder",
                          },
                        },
                        _vm._l(
                          _vm.dictionaries.order_main_close_reason,
                          function (item, index) {
                            return _c(
                              "el-radio",
                              {
                                key: index,
                                staticClass: "setPay_payment",
                                attrs: { label: item.dictId },
                              },
                              [_vm._v(_vm._s(item.dictName) + " ")]
                            )
                          }
                        ),
                        1
                      ),
                    ]
                  : [_c("p", [_vm._v("第三方的自动订单不能关闭")])],
                _c(
                  "div",
                  {
                    staticClass: "dialogBtnright dialogBtnright_right",
                    staticStyle: { "margin-top": "20px" },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "setPay_payment_btn_quxiao",
                        on: {
                          click: function ($event) {
                            _vm.dialog.visible = false
                          },
                        },
                      },
                      [_vm._v("取 消")]
                    ),
                    _vm.dialog.row.orderGenerateType == 1
                      ? _c(
                          "el-button",
                          {
                            staticClass: "setPay_payment_btn_queren",
                            attrs: { type: "primary" },
                            on: { click: _vm.handlerCloseOrderSubmit },
                          },
                          [_vm._v("确 定")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.dialog.type === "deriveRecord"
            ? [
                _c("lb-table", {
                  attrs: {
                    column: _vm.columnsDeriveRecord,
                    data: _vm.deriveRecordList.list,
                    pagination: "",
                    total: _vm.deriveRecordList.totalNum,
                    layout: "total, sizes, prev, pager, next, jumper",
                    "page-sizes": [5, 10, 20, 30, 50],
                    "current-page": _vm.page.currentPage,
                    "page-size": _vm.page.pageSize,
                  },
                  on: {
                    "update:currentPage": function ($event) {
                      return _vm.$set(_vm.page, "currentPage", $event)
                    },
                    "update:current-page": function ($event) {
                      return _vm.$set(_vm.page, "currentPage", $event)
                    },
                    "size-change": _vm.handleSizeChangeDeriveRecord,
                    "p-current-change": _vm.handleCurrentChangeDeriveRecord,
                  },
                }),
              ]
            : _vm._e(),
          _vm.dialog.type === "deriveFailOrder"
            ? [
                _c(
                  "div",
                  {
                    staticStyle: {
                      "text-align": "center",
                      margin: "20px 0",
                      "font-size": "16px",
                    },
                  },
                  [
                    _c("p", [
                      _vm._v(" 是否导出共"),
                      _c("span", [_vm._v(_vm._s(_vm.pageTotalNum))]),
                      _vm._v("条" + _vm._s(_vm.titleName) + "记录？ "),
                    ]),
                  ]
                ),
              ]
            : _vm._e(),
          _vm.dialog.type === "deriveDeliverGoods"
            ? [
                _c(
                  "div",
                  {
                    staticStyle: {
                      "text-align": "center",
                      margin: "10px 0",
                      "font-size": "16px",
                    },
                  },
                  [_c("p", [_vm._v(" 是否继续导出？ ")])]
                ),
              ]
            : _vm._e(),
          _vm.dialog.type === "deriveDeliverGoods1"
            ? [
                _c(
                  "div",
                  {
                    staticStyle: {
                      "text-align": "center",
                      margin: "10px 0",
                      "font-size": "16px",
                    },
                  },
                  [
                    _c("p", [
                      _vm._v(" 导出订单共有"),
                      _c(
                        "span",
                        {
                          staticStyle: { color: "red", "font-weight": "bold" },
                        },
                        [_vm._v(_vm._s(_vm.pageTotalNum))]
                      ),
                      _vm._v("条，是否确认导出？ "),
                    ]),
                  ]
                ),
              ]
            : _vm._e(),
          _vm.dialog.type !== "closeOrder" &&
          _vm.dialog.type !== "logisticsMessage" &&
          _vm.dialog.type !== "editWuliu" &&
          _vm.dialog.type !== "modifyOrderNoOne" &&
          _vm.dialog.type !== "logisticsMessageOne" &&
          _vm.dialog.type != "wuliuAbnormal" &&
          _vm.dialog.type != "shenheStep" &&
          _vm.dialog.type != "outStock"
            ? _c(
                "div",
                { staticClass: "btnClass" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", plain: "" },
                      on: {
                        click: function ($event) {
                          _vm.dialog.type == "deriveRecord" ||
                          _vm.dialog.type == "deriveDeliverGoods" ||
                          _vm.dialog.type == "deriveFailOrder" ||
                          _vm.dialog.type == "deriveDeliverGoods1"
                            ? (_vm.dialog.visible = false)
                            : _vm.closeDialog
                        },
                      },
                    },
                    [_vm._v(" 取消 ")]
                  ),
                  _vm.dialog.type !== "deriveDeliverGoods" &&
                  _vm.dialog.type !== "deriveDeliverGoods1" &&
                  _vm.dialog.type !== "deriveFailOrder"
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              _vm.dialog.type == "deriveRecord"
                                ? (_vm.dialog.visible = false)
                                : _vm.actionDialog
                            },
                          },
                        },
                        [_vm._v("确认 ")]
                      )
                    : _vm._e(),
                  _vm.dialog.type === "deriveDeliverGoods"
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.deriveDownload },
                        },
                        [_vm._v("确认")]
                      )
                    : _vm._e(),
                  _vm.dialog.type === "deriveFailOrder"
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.deriveDownload1 },
                        },
                        [_vm._v("确认")]
                      )
                    : _vm._e(),
                  _vm.dialog.type === "deriveDeliverGoods1"
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.deriveDownload2 },
                        },
                        [_vm._v("确认")]
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm.dialog.type === "modifyOrderNoOne"
            ? _c(
                "div",
                { staticClass: "dialog-btn" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "setPay_payment_btn_quxiao",
                      attrs: { type: "primary", plain: "" },
                      on: { click: _vm.closeDialog },
                    },
                    [_vm._v("取消")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "setPay_payment_btn_queren",
                      attrs: { type: "primary" },
                      on: { click: _vm.actionDialog },
                    },
                    [_vm._v("确认")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialoglogistics.title,
            visible: _vm.dialoglogistics.visible,
            width: _vm.dialoglogistics.width,
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialoglogistics, "visible", $event)
            },
          },
        },
        [
          _vm.dialoglogistics.type == "importlogistics" ||
          _vm.dialoglogistics.type == "batchAmend" ||
          _vm.dialoglogistics.type == "afterSaleLeadingIn"
            ? [
                _c(
                  "div",
                  { staticClass: "popIn" },
                  [
                    _c(
                      "el-upload",
                      {
                        ref: "tops",
                        staticClass: "upload-demo",
                        attrs: {
                          accept: ".doc,.docx,.xls,.xlsx,.csv",
                          drag: "",
                          action: "#",
                          multiple: false,
                          "http-request": _vm.orderImport,
                          limit: 1,
                        },
                      },
                      [
                        _c("i", { staticClass: "el-icon-upload" }),
                        _c("div", { staticClass: "el-upload__text" }, [
                          _vm._v(" 将文件拖到此处，或"),
                          _c("em", [_vm._v("点击上传")]),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _c("div", { staticClass: "dialog-footer" }, [
                  _c(
                    "div",
                    { on: { click: _vm.downloadTemplate } },
                    [
                      _c(
                        "el-button",
                        { attrs: { type: "text", icon: "el-icon-download" } },
                        [_vm._v("导入模板下载")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "cancel",
                          on: {
                            click: function ($event) {
                              _vm.dialoglogistics.visible = false
                              _vm.$refs["tops"].clearFiles()
                            },
                          },
                        },
                        [_vm._v("取消 ")]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "affirm",
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              _vm.templateMode()
                              _vm.$refs["tops"].clearFiles()
                            },
                          },
                        },
                        [_vm._v("确定 ")]
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            : _vm._e(),
          _vm.dialoglogistics.type == "importlogisticslast" ||
          _vm.dialoglogistics.type == "batchAmendlast" ||
          _vm.dialoglogistics.type == "afterSaleLeadingInlast"
            ? [
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.importLogisticsList.list,
                      "header-cell-style": { background: "#f8f8f8" },
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { prop: "date", label: "订单号", width: "184" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "header",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: { effect: "dark", placement: "top" },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticStyle: { color: "red" } },
                                      [_vm._v("*")]
                                    ),
                                  ]
                                ),
                                _vm._v(" 订单号 "),
                              ]
                            },
                          },
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("el-input", {
                                  attrs: {
                                    size: "mini",
                                    placeholder: "请输入内容",
                                  },
                                  model: {
                                    value: scope.row.orderNo,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "orderNo", $$v)
                                    },
                                    expression: "scope.row.orderNo",
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        101479543
                      ),
                    }),
                    _c(
                      "el-table-column",
                      {
                        attrs: {
                          prop: "name",
                          label: "物流单号",
                          width: "184",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("el-input", {
                                    attrs: {
                                      size: "mini",
                                      placeholder: "请输入内容",
                                    },
                                    model: {
                                      value: scope.row.logisticsNumber,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          scope.row,
                                          "logisticsNumber",
                                          $$v
                                        )
                                      },
                                      expression: "scope.row.logisticsNumber",
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1348280477
                        ),
                      },
                      [
                        _c(
                          "template",
                          { slot: "header" },
                          [
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: { effect: "dark", placement: "top" },
                              },
                              [
                                _c("span", { staticStyle: { color: "red" } }, [
                                  _vm._v("*"),
                                ]),
                              ]
                            ),
                            _vm._v(" 物流单号 "),
                          ],
                          1
                        ),
                      ],
                      2
                    ),
                    _c(
                      "el-table-column",
                      {
                        attrs: {
                          prop: "address",
                          label: "物流公司",
                          width: "184",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        filterable: "",
                                        clearable: "",
                                        placeholder: "请选择",
                                        size: "mini",
                                      },
                                      model: {
                                        value: scope.row.logisticsCompany,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "logisticsCompany",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "scope.row.logisticsCompany",
                                      },
                                    },
                                    _vm._l(
                                      _vm.dictionaries.courier_company,
                                      function (item) {
                                        return _c("el-option", {
                                          key: item.dictId,
                                          attrs: {
                                            label: item.dictName,
                                            value: item.dictId,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          830446679
                        ),
                      },
                      [
                        _c(
                          "template",
                          { slot: "header" },
                          [
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: { effect: "dark", placement: "top" },
                              },
                              [
                                _c("span", { staticStyle: { color: "red" } }, [
                                  _vm._v("*"),
                                ]),
                              ]
                            ),
                            _vm._v(" 物流公司 "),
                          ],
                          1
                        ),
                      ],
                      2
                    ),
                    _c("el-table-column", {
                      attrs: {
                        prop: "address",
                        label: "出货仓库（选填）",
                        width: "184",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      clearable: "",
                                      placeholder: "请选择",
                                      size: "mini",
                                    },
                                    model: {
                                      value: scope.row.commWarehouseId,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          scope.row,
                                          "commWarehouseId",
                                          $$v
                                        )
                                      },
                                      expression: "scope.row.commWarehouseId",
                                    },
                                  },
                                  _vm._l(
                                    _vm.commWarehouseList,
                                    function (item) {
                                      return _c("el-option", {
                                        key: item.id,
                                        attrs: {
                                          label: item.name,
                                          value: item.id,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        4012162039
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "address", label: "失败理由" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  " " + _vm._s(scope.row.failureReason) + " "
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1389415769
                      ),
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "block" },
                  [
                    _c("el-pagination", {
                      attrs: {
                        "current-page": _vm.currentPage1,
                        "page-sizes": [10, 20, 50, 100, 200],
                        "page-size": _vm.page.pageSize,
                        layout: "total, sizes, prev, pager, next, jumper",
                        total: _vm.importLogisticsList.totalNum,
                        "prev-text": "上一页",
                        "next-text": "下一页",
                      },
                      on: {
                        "size-change": _vm.handleSizeLogisticsTable,
                        "current-change": _vm.handleCurrentLogisticsTable,
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "dialogBtnright",
                    staticStyle: { "margin-top": "20px" },
                  },
                  [
                    _c(
                      "div",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", icon: "el-icon-download" },
                            on: { click: _vm.downloadThisLocality },
                          },
                          [_vm._v("下载到本地")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "setPay_payment_btn_quxiao",
                            on: {
                              click: function ($event) {
                                _vm.dialoglogistics.visible = false
                              },
                            },
                          },
                          [_vm._v("取 消")]
                        ),
                        _c(
                          "el-button",
                          {
                            staticClass: "setPay_payment_btn_queren",
                            attrs: { type: "primary" },
                            on: { click: _vm.resubmit },
                          },
                          [_vm._v("重新提交")]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "生成电子面单",
            visible: _vm.isProductOrder,
            width: "80%",
            "append-to-body": true,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isProductOrder = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "content" },
            [
              _c(
                "div",
                { staticStyle: { "margin-bottom": "10px" } },
                [
                  _c(
                    "el-form",
                    {
                      ref: "formAttrxsc",
                      attrs: {
                        model: _vm.searchFormConfig1.formData,
                        "label-width": "82px",
                        inline: true,
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "订单编号", prop: "orderNo" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "232px" },
                            attrs: {
                              size: "small",
                              placeholder: "请输入订单编号",
                            },
                            model: {
                              value: _vm.searchFormConfig1.formData.orderNo,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.searchFormConfig1.formData,
                                  "orderNo",
                                  $$v
                                )
                              },
                              expression: "searchFormConfig1.formData.orderNo",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "收货人信息", prop: "postInfo" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "232px" },
                            attrs: {
                              size: "small",
                              placeholder: "请输入收货人信息",
                            },
                            model: {
                              value: _vm.searchFormConfig1.formData.postInfo,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.searchFormConfig1.formData,
                                  "postInfo",
                                  $$v
                                )
                              },
                              expression: "searchFormConfig1.formData.postInfo",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "提交时间", prop: "createdTime" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "232px" },
                            attrs: {
                              type: "daterange",
                              size: "small",
                              "range-separator": "至",
                              "start-placeholder": "开始日期",
                              "end-placeholder": "结束日期",
                              "default-time": ["00:00:00", "23:59:59"],
                              format: "yyyy-MM-dd",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                            },
                            model: {
                              value: _vm.searchFormConfig1.formData.createdTime,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.searchFormConfig1.formData,
                                  "createdTime",
                                  $$v
                                )
                              },
                              expression:
                                "searchFormConfig1.formData.createdTime",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "留言/备注", prop: "remark" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "232px" },
                            attrs: {
                              size: "small",
                              placeholder: "请输入留言/备注",
                            },
                            model: {
                              value: _vm.searchFormConfig1.formData.remark,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.searchFormConfig1.formData,
                                  "remark",
                                  $$v
                                )
                              },
                              expression: "searchFormConfig1.formData.remark",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "物流公司",
                            prop: "logisticsCompanyCode",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "232px" },
                              attrs: {
                                placeholder: "请选择物流公司",
                                clearable: "",
                                size: "small",
                              },
                              model: {
                                value:
                                  _vm.searchFormConfig1.formData
                                    .logisticsCompanyCode,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.searchFormConfig1.formData,
                                    "logisticsCompanyCode",
                                    $$v
                                  )
                                },
                                expression:
                                  "searchFormConfig1.formData.logisticsCompanyCode",
                              },
                            },
                            _vm._l(
                              _vm.logisticsCompanyList,
                              function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                size: "small",
                                plain: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.dialogClickDan("search")
                                },
                              },
                            },
                            [_vm._v("查询")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                size: "small",
                                plain: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.dialogClickDan("reset")
                                },
                              },
                            },
                            [_vm._v("重置")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "start",
                    "margin-bottom": "10px",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "stock-up-send-but2",
                      on: {
                        click: function ($event) {
                          return _vm.openFailOrder()
                        },
                      },
                    },
                    [_vm._v("失败面单(" + _vm._s(_vm.ebillErrorCount) + ") ")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "stock-up-send-but5",
                      staticStyle: { "margin-left": "20px" },
                      on: {
                        click: function ($event) {
                          return _vm.showAddrDialogFn("")
                        },
                      },
                    },
                    [_vm._v("寄件地址设置 ")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "stock-up-send-but1",
                      staticStyle: {
                        width: "120px",
                        "margin-right": "20px",
                        "line-height": "36px",
                        cursor: "pointer",
                      },
                      on: { click: _vm.openShowCode },
                    },
                    [_vm._v("月结编码")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "stock-up-send-but3",
                      staticStyle: { "margin-left": "0" },
                      on: {
                        click: function ($event) {
                          return _vm.showSelectLogistics(1)
                        },
                      },
                    },
                    [_vm._v("批量选择物流 ")]
                  ),
                ]
              ),
              _c("lb-table", {
                directives: [
                  {
                    name: "horizontal-scroll",
                    rawName: "v-horizontal-scroll",
                    value: "always",
                    expression: "'always'",
                  },
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loadinglist,
                    expression: "loadinglist",
                  },
                ],
                ref: "sctable",
                attrs: {
                  isBorder: true,
                  tableRowStyle: _vm.tableRowStyle,
                  column: _vm.columns1,
                  data: _vm.tableListx,
                  pagination: "",
                  total: _vm.totalNumDan,
                  layout: "total, sizes, prev, pager, next, jumper",
                  "page-sizes": [5, 10, 20, 30, 50, 200],
                  "current-page": _vm.currentPageDan,
                  "page-size": _vm.pageSizeDan,
                },
                on: {
                  "update:currentPage": function ($event) {
                    _vm.currentPageDan = $event
                  },
                  "update:current-page": function ($event) {
                    _vm.currentPageDan = $event
                  },
                  "size-change": _vm.handleSizeChangeDan,
                  "p-current-change": _vm.handleCurrentChangeDan,
                  "selection-change": _vm.handleSelectionChangeDan,
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "end",
                "margin-top": "10px",
                "margin-bottom": "10px",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "cBtn",
                  on: {
                    click: function ($event) {
                      _vm.isProductOrder = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "div",
                {
                  staticClass: "qBtn",
                  on: {
                    click: function ($event) {
                      return _vm.createEbillBatch()
                    },
                  },
                },
                [_vm._v("生成电子面单")]
              ),
            ]
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "生成电子面单",
            visible: _vm.isROrder,
            width: "30%",
            "append-to-body": true,
            "before-close": _vm.qProuductOrder,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isROrder = $event
            },
          },
        },
        [
          _c("div", { staticClass: "content" }, [
            _c("div", { staticStyle: { "font-size": "16px" } }, [
              _vm._v("已成功生成电子面单"),
              _c("span", { staticStyle: { color: "#12AB62" } }, [
                _vm._v(_vm._s(_vm.successNum) + "条"),
              ]),
              _vm._v(",失败"),
              _c("span", { staticStyle: { color: "#FF0000" } }, [
                _vm._v(_vm._s(_vm.failNum) + "条"),
              ]),
              _vm._v("！"),
            ]),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "end",
                  "margin-top": "20px",
                  "margin-bottom": "10px",
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "cBtn", on: { click: _vm.qProuductOrder } },
                  [_vm._v("取消")]
                ),
                _c(
                  "div",
                  { staticClass: "qBtn", on: { click: _vm.qProuductOrder } },
                  [_vm._v("确定")]
                ),
              ]
            ),
          ]),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "失败面单",
            visible: _vm.failOrder,
            width: "72%",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.failOrder = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "content" },
            [
              _c(
                "div",
                { staticStyle: { "margin-bottom": "10px" } },
                [
                  _c(
                    "el-form",
                    {
                      ref: "formAttrx",
                      attrs: {
                        model: _vm.searchFormConfig2.formData,
                        "label-width": "82px",
                        inline: true,
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "生成批次", prop: "batchNo" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "232px" },
                            attrs: {
                              size: "small",
                              placeholder: "请输入生成批次",
                            },
                            model: {
                              value: _vm.searchFormConfig2.formData.batchNo,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.searchFormConfig2.formData,
                                  "batchNo",
                                  $$v
                                )
                              },
                              expression: "searchFormConfig2.formData.batchNo",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "订单编号", prop: "orderNo" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "232px" },
                            attrs: {
                              size: "small",
                              placeholder: "请输入订单编号",
                            },
                            model: {
                              value: _vm.searchFormConfig2.formData.orderNo,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.searchFormConfig2.formData,
                                  "orderNo",
                                  $$v
                                )
                              },
                              expression: "searchFormConfig2.formData.orderNo",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "收货人信息", prop: "postInfo" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "232px" },
                            attrs: {
                              size: "small",
                              placeholder: "请输入收货人信息",
                            },
                            model: {
                              value: _vm.searchFormConfig2.formData.postInfo,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.searchFormConfig2.formData,
                                  "postInfo",
                                  $$v
                                )
                              },
                              expression: "searchFormConfig2.formData.postInfo",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "提交时间", prop: "createdTime" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "232px" },
                            attrs: {
                              type: "daterange",
                              size: "small",
                              "range-separator": "至",
                              "start-placeholder": "开始日期",
                              "end-placeholder": "结束日期",
                              "default-time": ["00:00:00", "23:59:59"],
                              format: "yyyy-MM-dd",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                            },
                            model: {
                              value: _vm.searchFormConfig2.formData.createdTime,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.searchFormConfig2.formData,
                                  "createdTime",
                                  $$v
                                )
                              },
                              expression:
                                "searchFormConfig2.formData.createdTime",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "留言/备注", prop: "remark" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "232px" },
                            attrs: {
                              size: "small",
                              placeholder: "请输入留言/备注",
                            },
                            model: {
                              value: _vm.searchFormConfig2.formData.remark,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.searchFormConfig2.formData,
                                  "remark",
                                  $$v
                                )
                              },
                              expression: "searchFormConfig2.formData.remark",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "物流公司",
                            prop: "logisticsCompanyCode",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "232px" },
                              attrs: {
                                placeholder: "请选择物流公司",
                                clearable: "",
                                size: "small",
                              },
                              model: {
                                value:
                                  _vm.searchFormConfig2.formData
                                    .logisticsCompanyCode,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.searchFormConfig2.formData,
                                    "logisticsCompanyCode",
                                    $$v
                                  )
                                },
                                expression:
                                  "searchFormConfig2.formData.logisticsCompanyCode",
                              },
                            },
                            _vm._l(
                              _vm.logisticsCompanyList,
                              function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                size: "small",
                                plain: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.dialogClickFailDan("search")
                                },
                              },
                            },
                            [_vm._v("查询")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                size: "small",
                                plain: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.dialogClickFailDan("reset")
                                },
                              },
                            },
                            [_vm._v("重置")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "start",
                    "margin-bottom": "10px",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "stock-up-send-but5",
                      on: { click: _vm.exportFailOrder },
                    },
                    [_vm._v("导出发货")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "stock-up-send-but4",
                      on: {
                        click: function ($event) {
                          return _vm.onApplierExport("3")
                        },
                      },
                    },
                    [_vm._v("导出记录")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "stock-up-send-but3",
                      on: {
                        click: function ($event) {
                          return _vm.showSelectLogistics(2)
                        },
                      },
                    },
                    [_vm._v("批量重新生成")]
                  ),
                ]
              ),
              _c("lb-table", {
                directives: [
                  {
                    name: "horizontal-scroll",
                    rawName: "v-horizontal-scroll",
                    value: "always",
                    expression: "'always'",
                  },
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loadinglist,
                    expression: "loadinglist",
                  },
                ],
                ref: "sbtable",
                attrs: {
                  isBorder: true,
                  tableRowStyle: _vm.tableRowStyle,
                  column: _vm.columns2,
                  data: _vm.ebillErrorOrderList,
                  pagination: "",
                  total: _vm.totalNumFailDan,
                  layout: "total, sizes, prev, pager, next, jumper",
                  "page-sizes": [5, 10, 20, 30, 50, 200],
                  "current-page": _vm.currentPageFailDan,
                  "page-size": _vm.pageSizeFailDan,
                },
                on: {
                  "update:currentPage": function ($event) {
                    _vm.currentPageFailDan = $event
                  },
                  "update:current-page": function ($event) {
                    _vm.currentPageFailDan = $event
                  },
                  "size-change": _vm.handleSizeFailDanChange,
                  "p-current-change": _vm.handleCurrentChangeFailDan,
                  "selection-change": _vm.handleSelectionChangeFailDan,
                },
              }),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "打印电子面单",
            visible: _vm.isPrintOrder,
            width: "80%",
            "append-to-body": true,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isPrintOrder = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "content" },
            [
              _c(
                "div",
                { staticStyle: { "margin-bottom": "10px" } },
                [
                  _c(
                    "el-form",
                    {
                      ref: "searchForm1",
                      attrs: {
                        model: _vm.searchFormConfig3.formData,
                        "label-width": "100px",
                        inline: true,
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "生成批次", prop: "batchNo" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "232px" },
                            attrs: {
                              size: "small",
                              placeholder: "请输入生成批次",
                            },
                            model: {
                              value: _vm.searchFormConfig3.formData.batchNo,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.searchFormConfig3.formData,
                                  "batchNo",
                                  $$v
                                )
                              },
                              expression: "searchFormConfig3.formData.batchNo",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "订单编号", prop: "orderNo" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "232px" },
                            attrs: {
                              size: "small",
                              placeholder: "请输入订单编号",
                            },
                            model: {
                              value: _vm.searchFormConfig3.formData.orderNo,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.searchFormConfig3.formData,
                                  "orderNo",
                                  $$v
                                )
                              },
                              expression: "searchFormConfig3.formData.orderNo",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "运单号", prop: "logisticsNo" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "232px" },
                            attrs: {
                              size: "small",
                              placeholder: "请输入运单号",
                            },
                            model: {
                              value: _vm.searchFormConfig3.formData.logisticsNo,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.searchFormConfig3.formData,
                                  "logisticsNo",
                                  $$v
                                )
                              },
                              expression:
                                "searchFormConfig3.formData.logisticsNo",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "快递公司",
                            prop: "logisticsCompanyCode",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "232px" },
                              attrs: {
                                placeholder: "请选择快递公司",
                                clearable: "",
                                size: "small",
                              },
                              on: { change: _vm.fetchData3 },
                              model: {
                                value:
                                  _vm.searchFormConfig3.formData
                                    .logisticsCompanyCode,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.searchFormConfig3.formData,
                                    "logisticsCompanyCode",
                                    $$v
                                  )
                                },
                                expression:
                                  "searchFormConfig3.formData.logisticsCompanyCode",
                              },
                            },
                            _vm._l(
                              _vm.logisticsCompanyList,
                              function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "是否子母件",
                            prop: "multipleBagFlag",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "232px" },
                              attrs: {
                                placeholder: "请选择是否子母件",
                                clearable: "",
                                size: "small",
                              },
                              model: {
                                value:
                                  _vm.searchFormConfig3.formData
                                    .multipleBagFlag,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.searchFormConfig3.formData,
                                    "multipleBagFlag",
                                    $$v
                                  )
                                },
                                expression:
                                  "searchFormConfig3.formData.multipleBagFlag",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { value: "true", label: "是" },
                              }),
                              _c("el-option", {
                                attrs: { value: "false", label: "否" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.currentStatus1 != 5
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "打印时间", prop: "printTime" } },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "232px" },
                                attrs: {
                                  type: "daterange",
                                  size: "small",
                                  "range-separator": "至",
                                  "start-placeholder": "开始日期",
                                  "end-placeholder": "结束日期",
                                  "default-time": ["00:00:00", "23:59:59"],
                                  format: "yyyy-MM-dd",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                },
                                model: {
                                  value:
                                    _vm.searchFormConfig3.formData.printTime,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.searchFormConfig3.formData,
                                      "printTime",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "searchFormConfig3.formData.printTime",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "生成面单时间", prop: "createdTime" },
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "232px" },
                            attrs: {
                              type: "daterange",
                              size: "small",
                              "range-separator": "至",
                              "start-placeholder": "开始日期",
                              "end-placeholder": "结束日期",
                              "default-time": ["00:00:00", "23:59:59"],
                              format: "yyyy-MM-dd",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                            },
                            model: {
                              value: _vm.searchFormConfig3.formData.createdTime,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.searchFormConfig3.formData,
                                  "createdTime",
                                  $$v
                                )
                              },
                              expression:
                                "searchFormConfig3.formData.createdTime",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "下单时间", prop: "orderTime" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "232px" },
                            attrs: {
                              type: "daterange",
                              size: "small",
                              "range-separator": "至",
                              "start-placeholder": "开始日期",
                              "end-placeholder": "结束日期",
                              "default-time": ["00:00:00", "23:59:59"],
                              format: "yyyy-MM-dd",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                            },
                            model: {
                              value: _vm.searchFormConfig3.formData.orderTime,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.searchFormConfig3.formData,
                                  "orderTime",
                                  $$v
                                )
                              },
                              expression:
                                "searchFormConfig3.formData.orderTime",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm.currentStatus1 == 5
                        ? _c(
                            "el-form-item",
                            {
                              attrs: { label: "撤销时间", prop: "cancelTime" },
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "232px" },
                                attrs: {
                                  type: "daterange",
                                  size: "small",
                                  "range-separator": "至",
                                  "start-placeholder": "开始日期",
                                  "end-placeholder": "结束日期",
                                  "default-time": ["00:00:00", "23:59:59"],
                                  format: "yyyy-MM-dd",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                },
                                model: {
                                  value:
                                    _vm.searchFormConfig3.formData.cancelTime,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.searchFormConfig3.formData,
                                      "cancelTime",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "searchFormConfig3.formData.cancelTime",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                size: "small",
                                plain: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.fetchData3("search")
                                },
                              },
                            },
                            [_vm._v("查询")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                size: "small",
                                plain: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.fetchData3("reset")
                                },
                              },
                            },
                            [_vm._v("重置")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "space-between",
                    "margin-bottom": "10px",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "left" },
                    _vm._l(_vm.logisticsStatus1, function (val, key) {
                      return _c(
                        "el-button",
                        {
                          key: key,
                          attrs: {
                            disabled: _vm.loading,
                            type:
                              _vm.currentStatus1 === val.values
                                ? "primary"
                                : "info",
                            size: "small",
                            plain: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.onChangeLogisticsStatus1(val.values)
                            },
                          },
                        },
                        [
                          _vm._v(_vm._s(val.title)),
                          _c("span", [_vm._v("（" + _vm._s(val.total) + "）")]),
                        ]
                      )
                    }),
                    1
                  ),
                  _c("div", { staticStyle: { display: "flex" } }, [
                    _vm.currentStatus1 == 2 && _vm.isPreview1
                      ? _c(
                          "div",
                          {
                            staticClass: "stock-up-send-but3",
                            staticStyle: { "margin-right": "20px" },
                            on: { click: _vm.lotsPrintOrder },
                          },
                          [_vm._v("批量预览打印")]
                        )
                      : _vm._e(),
                    _vm.currentStatus1 == 2 || _vm.currentStatus1 == "3"
                      ? _c(
                          "div",
                          {
                            staticClass: "stock-up-send-but5",
                            on: { click: _vm.exportPickOrder },
                          },
                          [_vm._v(" 导出拣货单")]
                        )
                      : _vm._e(),
                    _vm.currentStatus1 == "2"
                      ? _c(
                          "div",
                          {
                            staticClass: "stock-up-send-but4",
                            on: {
                              click: function ($event) {
                                return _vm.onApplierExport("2")
                              },
                            },
                          },
                          [_vm._v("导出记录")]
                        )
                      : _vm._e(),
                    _vm.currentStatus1 == "" || _vm.currentStatus1 == "5"
                      ? _c(
                          "div",
                          {
                            staticClass: "stock-up-send-but5",
                            staticStyle: { "margin-left": "10px" },
                            on: { click: _vm.exportPrintOrder },
                          },
                          [_vm._v(" 导出")]
                        )
                      : _vm._e(),
                  ]),
                ]
              ),
              _c("lb-table", {
                directives: [
                  {
                    name: "horizontal-scroll",
                    rawName: "v-horizontal-scroll",
                    value: "always",
                    expression: "'always'",
                  },
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loadinglist,
                    expression: "loadinglist",
                  },
                ],
                attrs: {
                  column: _vm.columns3,
                  data: _vm.printOrderList,
                  pagination: "",
                  total: _vm.totalNum3,
                  layout: "total, sizes, prev, pager, next, jumper",
                  "page-sizes": [5, 10, 20, 30, 50, 200],
                  "current-page": _vm.pageNo3,
                  "page-size": _vm.pageSize3,
                },
                on: {
                  "update:currentPage": function ($event) {
                    _vm.pageNo3 = $event
                  },
                  "update:current-page": function ($event) {
                    _vm.pageNo3 = $event
                  },
                  "size-change": _vm.handleSizeChange3,
                  "p-current-change": _vm.handleCurrentChange3,
                  "selection-change": _vm.handleSelectionChange3,
                },
              }),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.titleLogistics,
            visible: _vm.isSelectLogistics,
            width: "30%",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isSelectLogistics = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "dialog-title",
              attrs: { slot: "title" },
              slot: "title",
            },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    "font-size": "18px",
                    "font-family": "PingFang SC",
                    "font-weight": "bold",
                    "line-height": "25px",
                  },
                },
                [
                  _vm._v(
                    _vm._s(_vm.isBatch == 1 ? "批量选择物流" : "批量重新生成")
                  ),
                ]
              ),
              _c("span", { staticStyle: { color: "#4168E7" } }, [
                _vm._v(
                  "（已选" + _vm._s(_vm.waitOrderList.length) + "条订单）"
                ),
              ]),
            ]
          ),
          _c(
            "div",
            { staticClass: "content" },
            [
              _c(
                "el-form",
                {
                  ref: "logisticsForm",
                  staticStyle: { "margin-top": "10px" },
                  attrs: {
                    model: _vm.batchLogistics,
                    rules: _vm.batchRules,
                    "label-width": "120px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { "margin-bottom": "20px" },
                      attrs: {
                        label: "物流公司",
                        prop: "logisticsCompanyCode",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请选择物流公司" },
                          on: {
                            change: function ($event) {
                              return _vm.selectLD($event)
                            },
                          },
                          model: {
                            value: _vm.batchLogistics.logisticsCompanyCode,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.batchLogistics,
                                "logisticsCompanyCode",
                                $$v
                              )
                            },
                            expression: "batchLogistics.logisticsCompanyCode",
                          },
                        },
                        _vm._l(_vm.logisticsCompanyList, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { "margin-bottom": "20px" },
                      attrs: {
                        label: "月结编号",
                        prop: "logisticsCustomerCode",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请选择月结编号" },
                          model: {
                            value: _vm.batchLogistics.logisticsCustomerCode,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.batchLogistics,
                                "logisticsCustomerCode",
                                $$v
                              )
                            },
                            expression: "batchLogistics.logisticsCustomerCode",
                          },
                        },
                        _vm._l(_vm.monthCodeList, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { "margin-bottom": "20px" },
                      attrs: {
                        label: "寄件产品类型",
                        prop: "logisticsProductType",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请选择寄件产品类型" },
                          model: {
                            value: _vm.batchLogistics.logisticsProductType,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.batchLogistics,
                                "logisticsProductType",
                                $$v
                              )
                            },
                            expression: "batchLogistics.logisticsProductType",
                          },
                        },
                        _vm._l(_vm.productTypeList, function (item) {
                          return _c("el-option", {
                            key: item.productTypeCode,
                            attrs: {
                              label: item.productTypeName,
                              value: item.productTypeCode,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { "margin-bottom": "20px" },
                      attrs: { label: "寄件人信息", prop: "sendAddressId" },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请选择寄件人信息" },
                          model: {
                            value: _vm.batchLogistics.sendAddressId,
                            callback: function ($$v) {
                              _vm.$set(_vm.batchLogistics, "sendAddressId", $$v)
                            },
                            expression: "batchLogistics.sendAddressId",
                          },
                        },
                        _vm._l(_vm.tableAddressList, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.isBatch == 1
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "打印备注",
                            prop: "logisticsPrintRemark",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              placeholder: "请输入打印备注",
                              maxlength: "200",
                              "show-word-limit": "",
                            },
                            model: {
                              value: _vm.batchLogistics.logisticsPrintRemark,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.batchLogistics,
                                  "logisticsPrintRemark",
                                  $$v
                                )
                              },
                              expression: "batchLogistics.logisticsPrintRemark",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "end",
                    "margin-top": "40px",
                    "margin-bottom": "10px",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "cBtn",
                      on: {
                        click: function ($event) {
                          _vm.isSelectLogistics = false
                          _vm.waitOrderList = []
                          _vm.clearSelection()
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "qBtn",
                      on: { click: _vm.batchLogisticsFn },
                    },
                    [_vm._v("确定")]
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "寄件地址设置",
            visible: _vm.showAddrDialog,
            width: "38.1%",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showAddrDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "dialog-title",
              attrs: { slot: "title" },
              slot: "title",
            },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    "font-size": "18px",
                    "font-family": "PingFang SC",
                    "font-weight": "bold",
                    "line-height": "25px",
                  },
                },
                [_vm._v("寄件地址设置")]
              ),
            ]
          ),
          _c(
            "div",
            { staticClass: "content" },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.addressList,
                    border: "",
                    "header-cell-style": { background: "#f7f7f7" },
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "name", label: "寄件人姓名", width: "160" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-input", {
                              model: {
                                value: scope.row.name,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "name", $$v)
                                },
                                expression: "scope.row.name",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "phone", label: "寄件人电话", width: "160" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-input", {
                              model: {
                                value: scope.row.phone,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "phone", $$v)
                                },
                                expression: "scope.row.phone",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "address", label: "寄件地址", width: "290" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-input", {
                              model: {
                                value: scope.row.address,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "address", $$v)
                                },
                                expression: "scope.row.address",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "操作", width: "80" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                staticStyle: { color: "red" },
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.delAddr(scope.$index)
                                  },
                                },
                              },
                              [_vm._v("删除")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    "text-align": "center",
                    "font-size": "16px",
                    color: "#4168E7",
                    width: "100%",
                    height: "56px",
                    "line-height": "56px",
                    border: "1px solid #4168E7",
                    cursor: "pointer",
                  },
                  on: { click: _vm.addAddr },
                },
                [_vm._v(" +添加 ")]
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "center",
                    "margin-top": "20px",
                    "margin-bottom": "10px",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "qBtn", on: { click: _vm.saveAddr } },
                    [_vm._v("保存")]
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "月结编码",
            visible: _vm.showCodeDialog,
            width: "40.4%",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showCodeDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "dialog-title",
              attrs: { slot: "title" },
              slot: "title",
            },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    "font-size": "18px",
                    "font-family": "PingFang SC",
                    "font-weight": "bold",
                    "line-height": "25px",
                  },
                },
                [_vm._v("月结编码")]
              ),
            ]
          ),
          _c(
            "div",
            { staticClass: "content" },
            [
              _vm._l(_vm.codeList, function (item, index) {
                return _c(
                  "div",
                  { key: index, staticStyle: { "margin-bottom": "20px" } },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                          "margin-bottom": "8px",
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "margin-right": "12px",
                              "font-size": "16px",
                              color: "#333",
                            },
                          },
                          [_vm._v(_vm._s(item.company))]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              plain: "",
                              size: "small",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.addCode("add", item.code)
                              },
                            },
                          },
                          [_vm._v("添加")]
                        ),
                      ],
                      1
                    ),
                    item.list.length > 0
                      ? _c(
                          "el-table",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              data: item.list,
                              border: "",
                              "header-cell-style": { background: "#f7f7f7" },
                            },
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "companyName",
                                label: "主体公司",
                                width: "160",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "code",
                                label: "月结编码",
                                width: "160",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "number",
                                label: "代收账号",
                                width: "290",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("p", [
                                          _vm._v(
                                            "开户银行：" +
                                              _vm._s(scope.row.collectionBank)
                                          ),
                                        ]),
                                        _c("p", [
                                          _vm._v(
                                            "姓名：" +
                                              _vm._s(scope.row.collectionName)
                                          ),
                                        ]),
                                        _c("p", [
                                          _vm._v(
                                            "卡号：" +
                                              _vm._s(
                                                scope.row.collectionAccount
                                              )
                                          ),
                                        ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: { label: "操作", width: "120" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "text",
                                              size: "small",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.addCode(
                                                  "edit",
                                                  scope.row
                                                    .logisticsCompanyCode,
                                                  scope.row.id,
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("编辑")]
                                        ),
                                        _c(
                                          "el-button",
                                          {
                                            staticStyle: { color: "red" },
                                            attrs: {
                                              type: "text",
                                              size: "small",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.deleteCode(
                                                  scope.row
                                                    .logisticsCompanyCode,
                                                  scope.row.id
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("删除")]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                )
              }),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "center",
                    "margin-top": "20px",
                    "margin-bottom": "10px",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "qBtn",
                      on: {
                        click: function ($event) {
                          _vm.showCodeDialog = false
                        },
                      },
                    },
                    [_vm._v("保存")]
                  ),
                ]
              ),
            ],
            2
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.titleLogistics,
            visible: _vm.showNewCodeDialog,
            width: "30%",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showNewCodeDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "dialog-title",
              attrs: { slot: "title" },
              slot: "title",
            },
            [
              this.optionCodeType == "add"
                ? _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "18px",
                        "font-family": "PingFang SC",
                        "font-weight": "bold",
                        "line-height": "25px",
                      },
                    },
                    [_vm._v("新增月结编码")]
                  )
                : _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "18px",
                        "font-family": "PingFang SC",
                        "font-weight": "bold",
                        "line-height": "25px",
                      },
                    },
                    [_vm._v("编辑月结编码")]
                  ),
            ]
          ),
          _c(
            "div",
            { staticClass: "content" },
            [
              _c(
                "el-form",
                {
                  ref: "infoFormC",
                  staticStyle: { "margin-top": "10px" },
                  attrs: { "label-width": "100px" },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "主体公司" } },
                    [
                      _c("el-input", {
                        attrs: { type: "text", placeholder: "请输入主体公司" },
                        model: {
                          value: _vm.infoFormC.companyName,
                          callback: function ($$v) {
                            _vm.$set(_vm.infoFormC, "companyName", $$v)
                          },
                          expression: "infoFormC.companyName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "月结编号" } },
                    [
                      _c("el-input", {
                        attrs: { type: "text", placeholder: "请输入月结编码" },
                        model: {
                          value: _vm.infoFormC.code,
                          callback: function ($$v) {
                            _vm.$set(_vm.infoFormC, "code", $$v)
                          },
                          expression: "infoFormC.code",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "开户银行" } },
                    [
                      _c("el-input", {
                        attrs: { type: "text", placeholder: "请输入开户银行" },
                        model: {
                          value: _vm.infoFormC.collectionBank,
                          callback: function ($$v) {
                            _vm.$set(_vm.infoFormC, "collectionBank", $$v)
                          },
                          expression: "infoFormC.collectionBank",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "姓名" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "text",
                          placeholder: "请输入持卡人姓名",
                        },
                        model: {
                          value: _vm.infoFormC.collectionName,
                          callback: function ($$v) {
                            _vm.$set(_vm.infoFormC, "collectionName", $$v)
                          },
                          expression: "infoFormC.collectionName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "卡号" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "text",
                          placeholder: "请输入银行卡卡号",
                        },
                        model: {
                          value: _vm.infoFormC.collectionAccount,
                          callback: function ($$v) {
                            _vm.$set(_vm.infoFormC, "collectionAccount", $$v)
                          },
                          expression: "infoFormC.collectionAccount",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "end",
                    "margin-top": "40px",
                    "margin-bottom": "10px",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "cBtn",
                      on: {
                        click: function ($event) {
                          _vm.showNewCodeDialog = false
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                  _c(
                    "div",
                    { staticClass: "qBtn", on: { click: _vm.submitCode } },
                    [_vm._v("确定")]
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "撤销面单",
            visible: _vm.isCOrder,
            width: "30%",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isCOrder = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "dialog-title",
              attrs: { slot: "title" },
              slot: "title",
            },
            [
              _c("i", {
                staticClass: "el-icon-warning",
                staticStyle: { "font-size": "22px", color: "orange" },
              }),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-size": "18px",
                    "font-family": "PingFang SC",
                    "font-weight": "bold",
                    "line-height": "30px",
                    color: "#333333",
                    "margin-left": "12px",
                  },
                },
                [_vm._v("撤销面单")]
              ),
            ]
          ),
          _c("div", { staticClass: "content" }, [
            _c("div", { staticStyle: { "font-size": "16px" } }, [
              _vm._v("是否确认【撤销】该订单的电子面单？撤销后其【"),
              _c("span", { staticStyle: { color: "red" } }, [
                _vm._v("子母单面单"),
              ]),
              _vm._v("】也会撤销！"),
            ]),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "end",
                  "margin-top": "20px",
                  "margin-bottom": "10px",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "cBtn",
                    on: {
                      click: function ($event) {
                        _vm.isCOrder = false
                      },
                    },
                  },
                  [_vm._v("取消")]
                ),
                _c(
                  "div",
                  { staticClass: "qBtn", on: { click: _vm.submitCmorder } },
                  [_vm._v("确定")]
                ),
              ]
            ),
          ]),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "撤销拆单",
            visible: _vm.isSOrder,
            width: "643px",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isSOrder = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "dialog-title",
              attrs: { slot: "title" },
              slot: "title",
            },
            [
              _c("i", {
                staticClass: "el-icon-warning",
                staticStyle: { "font-size": "22px", color: "orange" },
              }),
              _vm.sType == 0
                ? _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "18px",
                        "font-family": "PingFang SC",
                        "font-weight": "bold",
                        "line-height": "30px",
                        color: "#333333",
                        "margin-left": "12px",
                      },
                    },
                    [_vm._v("撤销拆单")]
                  )
                : _vm._e(),
              _vm.sType == 1
                ? _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "18px",
                        "font-family": "PingFang SC",
                        "font-weight": "bold",
                        "line-height": "30px",
                        color: "#333333",
                        "margin-left": "12px",
                      },
                    },
                    [_vm._v("母订单撤销拆单")]
                  )
                : _vm._e(),
            ]
          ),
          _c("div", { staticClass: "content" }, [
            _c(
              "div",
              {
                staticStyle: {
                  "font-size": "16px",
                  "font-family": "PingFang SC",
                  "font-weight": "400",
                  "line-height": "0px",
                  color: "#333333",
                  "margin-left": "20px",
                },
              },
              [_vm._v(" 是否确认撤销拆单？ ")]
            ),
            _c(
              "div",
              {
                staticStyle: {
                  width: "580px",
                  "min-height": "62px",
                  background: "#F5F8FF",
                  opacity: "1",
                  "border-radius": "0px",
                  "margin-top": "20px",
                  "margin-left": "20px",
                },
              },
              [
                _c("div", { staticStyle: { padding: "8px 12px" } }, [
                  _vm._v(" 注意：撤销后，"),
                  _vm.sType == 0 ? _c("span", [_vm._v("原")]) : _vm._e(),
                  _vm.sType == 1 ? _c("span", [_vm._v("母")]) : _vm._e(),
                  _vm._v("订单拆单的所有订单"),
                  _c("span", { staticStyle: { color: "red" } }, [
                    _vm._v("【"),
                    _vm.sType == 0
                      ? _c("span", [
                          _vm._v("合计母订单" + _vm._s(_vm.isNum) + "条 "),
                        ])
                      : _vm._e(),
                    _vm.sType == 1
                      ? _c("span", [
                          _vm._v("合计子订单" + _vm._s(_vm.isNum) + "条"),
                        ])
                      : _vm._e(),
                    _vm._v("】"),
                  ]),
                  _vm._v("都撤销拆单！是否确认拆单？"),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "end",
                  "margin-top": "20px",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "cBtn",
                    on: {
                      click: function ($event) {
                        _vm.isSOrder = false
                      },
                    },
                  },
                  [_vm._v("取消")]
                ),
                _c(
                  "div",
                  { staticClass: "qBtn", on: { click: _vm.qSumitSplit } },
                  [_vm._v("确定")]
                ),
              ]
            ),
          ]),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "打印面单",
            visible: _vm.printOrderDialog,
            width: "30%",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.printOrderDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "dialog-title",
              attrs: { slot: "title" },
              slot: "title",
            },
            [
              _c("i", {
                staticClass: "el-icon-warning",
                staticStyle: { "font-size": "22px", color: "orange" },
              }),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-size": "18px",
                    "font-family": "PingFang SC",
                    "font-weight": "bold",
                    "line-height": "30px",
                    color: "#333333",
                    "margin-left": "12px",
                  },
                },
                [_vm._v("打印面单")]
              ),
            ]
          ),
          _c("div", { staticClass: "content" }, [
            _c("div", { staticStyle: { "font-size": "16px" } }, [
              _vm._v("确认打印所选订单的电子面单？"),
            ]),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "end",
                  "margin-top": "20px",
                  "margin-bottom": "10px",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "cBtn",
                    on: {
                      click: function ($event) {
                        _vm.printOrderDialog = false
                      },
                    },
                  },
                  [_vm._v("取消")]
                ),
                _c(
                  "div",
                  {
                    staticClass: "qBtn",
                    attrs: { id: "printContext" },
                    on: { click: _vm.printT },
                  },
                  [
                    _vm._v("确认 "),
                    _c("printModel", {
                      staticStyle: { display: "none" },
                      attrs: { printData: _vm.printData },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ]),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "批量打印",
            visible: _vm.isExportPrint,
            width: "30%",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isExportPrint = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "dialog-title",
              attrs: { slot: "title" },
              slot: "title",
            },
            [
              _c("i", {
                staticClass: "el-icon-warning",
                staticStyle: { "font-size": "22px", color: "orange" },
              }),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-size": "18px",
                    "font-family": "PingFang SC",
                    "font-weight": "bold",
                    "line-height": "30px",
                    color: "#333333",
                    "margin-left": "12px",
                  },
                },
                [_vm._v("批量打印")]
              ),
            ]
          ),
          _c("div", { staticClass: "content" }, [
            _c("div", { staticStyle: { "font-size": "16px" } }, [
              _vm._v("确认批量打印所选订单的电子面单？"),
            ]),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "end",
                  "margin-top": "20px",
                  "margin-bottom": "10px",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "cBtn",
                    on: {
                      click: function ($event) {
                        _vm.isExportPrint = false
                      },
                    },
                  },
                  [_vm._v("取消")]
                ),
                _c(
                  "div",
                  { staticClass: "qBtn", on: { click: _vm.lotPrintSubmit } },
                  [_vm._v("确定")]
                ),
              ]
            ),
          ]),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "重打面单",
            visible: _vm.isAgainPrint,
            width: "30%",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isAgainPrint = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "dialog-title",
              attrs: { slot: "title" },
              slot: "title",
            },
            [
              _c("i", {
                staticClass: "el-icon-warning",
                staticStyle: { "font-size": "22px", color: "orange" },
              }),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-size": "18px",
                    "font-family": "PingFang SC",
                    "font-weight": "bold",
                    "line-height": "30px",
                    color: "#333333",
                    "margin-left": "12px",
                  },
                },
                [_vm._v("重打面单")]
              ),
            ]
          ),
          _c("div", { staticClass: "content" }, [
            _c("div", { staticStyle: { "font-size": "16px" } }, [
              _vm._v("是否确认重新打印该订单的电子面单？"),
            ]),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "end",
                  "margin-top": "20px",
                  "margin-bottom": "10px",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "cBtn",
                    on: {
                      click: function ($event) {
                        _vm.isAgainPrint = false
                      },
                    },
                  },
                  [_vm._v("取消")]
                ),
                _c("div", { staticClass: "qBtn" }, [_vm._v("确定")]),
              ]
            ),
          ]),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "提示信息",
            visible: _vm.isDeleteCode,
            width: "30%",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isDeleteCode = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "dialog-title",
              attrs: { slot: "title" },
              slot: "title",
            },
            [
              _c("i", {
                staticClass: "el-icon-warning",
                staticStyle: { "font-size": "22px", color: "orange" },
              }),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-size": "18px",
                    "font-family": "PingFang SC",
                    "font-weight": "bold",
                    "line-height": "30px",
                    color: "#333333",
                    "margin-left": "12px",
                  },
                },
                [_vm._v("提示信息")]
              ),
            ]
          ),
          _c("div", { staticClass: "content" }, [
            _c("div", { staticStyle: { "font-size": "16px" } }, [
              _vm._v("删除后不可恢复数据，是否继续？"),
            ]),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "end",
                  "margin-top": "20px",
                  "margin-bottom": "10px",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "cBtn",
                    on: {
                      click: function ($event) {
                        _vm.isDeleteCode = false
                      },
                    },
                  },
                  [_vm._v("取消")]
                ),
                _c(
                  "div",
                  { staticClass: "qBtn", on: { click: _vm.submitDeleteCode } },
                  [_vm._v("确定")]
                ),
              ]
            ),
          ]),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择打印模板",
            visible: _vm.isPrintM,
            width: "30%",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isPrintM = $event
            },
          },
        },
        [
          _c("div", { staticClass: "content" }, [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "space-between",
                  "flex-wrap": "wrap",
                },
              },
              _vm._l(_vm.printModels, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    class: { activeModel: index == _vm.printModelIndex },
                    staticStyle: { width: "172px" },
                    on: {
                      click: function ($event) {
                        return _vm.selectPrintModel(item, index)
                      },
                    },
                  },
                  [
                    _c("div", [
                      _c("img", {
                        staticStyle: {
                          width: "128px",
                          height: "128px",
                          "margin-top": "32px",
                          "margin-left": "22px",
                        },
                        attrs: { src: require("../../assets/img_moban.png") },
                      }),
                    ]),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          padding: "17px 17px",
                          "font-family": "PingFang SC",
                          "font-size": "14px",
                          "font-weight": "bold",
                          "line-height": "20px",
                          color: "#333333",
                        },
                      },
                      [_vm._v(" " + _vm._s(item.name))]
                    ),
                  ]
                )
              }),
              0
            ),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "end",
                  "margin-top": "20px",
                  "margin-bottom": "10px",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "cBtn",
                    on: {
                      click: function ($event) {
                        _vm.isPrintM = false
                      },
                    },
                  },
                  [_vm._v("取消")]
                ),
                _c(
                  "div",
                  { staticClass: "qBtn", on: { click: _vm.printModelData } },
                  [_vm._v("确定")]
                ),
              ]
            ),
          ]),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "预览",
            visible: _vm.isPreview,
            width: "30%",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isPreview = $event
            },
          },
        },
        [
          _c("div", { staticClass: "content" }, [
            _vm.isDB
              ? _c(
                  "div",
                  { staticStyle: { height: "600px", "overflow-y": "auto" } },
                  [
                    _c("printModel", {
                      staticStyle: { "margin-left": "100px" },
                      attrs: { printData: _vm.printData },
                    }),
                  ],
                  1
                )
              : _c("iframe", {
                  staticStyle: { width: "100%", height: "600px" },
                  attrs: { src: _vm.pdfUrl },
                }),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "end",
                  "margin-top": "20px",
                  "margin-bottom": "10px",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "qBtn",
                    on: {
                      click: function ($event) {
                        _vm.isPreview = false
                      },
                    },
                  },
                  [_vm._v("确定")]
                ),
              ]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }